import { useState, useRef, useEffect } from "react";

export const CustomLicenseField = ({ name, label, prefix = null, suffix = null, mask, value, onChange, readOnly }) => {

  const [ currentText, setCurrentText ] = useState( mask.split('').reduce((text, maskChar, index) => {
    let newChar
    switch ( maskChar ) {
      case 'a':
        if ( value[index] && value[index].match(/[a-zA-Z]/) ) newChar = value[index]
        else newChar = '_'
        break
      case '9':
        if ( value[index] && value[index].match(/[0-9]/) ) newChar = value[index]
        else newChar = '_'
        break
      case '*':
        if ( value[index] && value[index].match(/[a-zA-Z0-9]/) ) newChar = value[index]
        else newChar = '_'
        break
      default:
        newChar = maskChar
        break
    }

    return text + newChar
  }, ''))
  const [ cursor, setCursor ] = useState({ position: 0 })
  const ref = useRef(null)

  useEffect(() => {
    if ( currentText !== value && onChange ) {
      let returnValue = currentText.replaceAll('_', '');
      // for ( let i = 0; i < currentText.length; i++ ) {
      //   if ( currentText[i] === '_' && mask[i] !== '_' ) break
      //   returnValue += currentText[i]
      // }
      onChange({ value: returnValue, display_value: `${prefix ?? ''}${returnValue}${suffix ?? ''}` })
    }
  }, [ currentText ])

  useEffect(() => {
    if ( cursor ) ref.current.setSelectionRange(cursor.position, cursor.position)
  }, [ ref, cursor, currentText ])


  const handleInput = (e) => {
    const eventType = e.nativeEvent.inputType
    const char = e.nativeEvent.data

    if ( char && eventType === 'insertText' ) {
      const maskChar = mask[e.nativeEvent.target.selectionEnd - 1]
      const newText = currentText.split('')

      switch ( maskChar ) {
        case 'a':
          if ( char.match(/[a-zA-Z]/) ) {
            newText[e.nativeEvent.target.selectionEnd - 1] = char
            setCursor({ position: e.target.selectionEnd })
          } else {
            setCursor({ position: e.target.selectionEnd - 1 })
          }
          break
        case '9':
          if ( char.match(/[0-9]/) ) {
            newText[e.nativeEvent.target.selectionEnd - 1] = char
            setCursor({ position: e.target.selectionEnd })
          } else {
            setCursor({ position: e.target.selectionEnd - 1 })
          }
          break
        case '*':
          if ( char.match(/[a-zA-Z0-9]/) ) {
            newText[e.nativeEvent.target.selectionEnd - 1] = char
            setCursor({ position: e.target.selectionEnd })
          } else {
            setCursor({ position: e.target.selectionEnd - 1 })
          }
          break
        default:
          setCursor({ position: e.target.selectionEnd })
          break
      }
      setCurrentText(newText.join(''))

    } else if ( eventType === 'deleteContentBackward' || eventType === 'deleteContentForward' ) {
      const index = e.nativeEvent.target.selectionEnd
      const maskChar = mask[index]
      const newText = currentText.split('')

      if ( maskChar === 'a' || maskChar === '9' || maskChar === '*' ) {
        newText[index] = '_'
      }

      setCurrentText(newText.join(''))
      setCursor({ position: index })

    } else {
      setCursor({ position: cursor ? cursor.position : 0 })
      e.preventDefault()
    }
  }

  return (
    <div className="tgbl-interface">
      <div className="tf-field tf-field--text">
        <label htmlFor={name} className="tf-field__label">{label}</label>
        <div className="tf-field__input">
          { prefix && <span className="tf-field__input__part tf-field__input__part--prefix">{prefix}</span> }
          <input
            ref={ref}
            type="text"
            id={name}
            disabled={readOnly}
            value={currentText}
            onInput={handleInput}
            onBlur={() => setCursor(null)}
            autoComplete={"off"}
          />
          { suffix && <span className="tf-field__input__part tf-field__input__part--suffix">{suffix}</span> }
        </div>
      </div>
    </div>
  )
}
